// @flow

import React, { Component, type ComponentType } from 'react';
import { connect } from 'react-redux';
import { getUiSetting, setUiSetting } from '../../store/uiStore';

type OwnProps = {
  id?: ?number,
};

type StateProps = {|
  open: boolean,
|};

export type DispatchProps = {|
  handleOpen: Function,
  handleClose: Function,
|};

export type HandleComponentToggleProps = OwnProps & StateProps & DispatchProps;

type InjectedProps = {
  handleOpen: Function | void,
  handleClose: Function | void,
  open: boolean | void,
};

export default (uiProperty: string) => function withHandleComponentToggle <Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<$Diff<Props & OwnProps, InjectedProps>> {
  class ComponentToggle extends Component<Props & HandleComponentToggleProps> {
    componentWillUnmount() {
      this.removeBodyEventListener();
    }

    removeBodyEventListener = () => {
      if (document.body) {
        document.body.removeEventListener('click', this.handleClose);
      }
    }

    handleClose = () => {
      const { handleClose, id } = this.props;
      this.removeBodyEventListener();
      handleClose(id);
    }

    addBodyEventListener = () => {
      if (document.body) {
        document.body.addEventListener('click', this.handleClose);
      }
    }

    handleOpen = () => {
      const { handleOpen, id } = this.props;
      this.addBodyEventListener();
      handleOpen(id);
    }

    render() {
      const {
        handleClose,
        ...rest
      } = this.props;
      return (
        <WrappedComponent
          {...rest}
          handleOpen={() => this.handleOpen()}
          handleClose={() => this.handleClose()}
        />
      );
    }
  }

  const mapStateToProps = (state: any, { id }: OwnProps): StateProps => ({
    open: getUiSetting(state, `${uiProperty}${id || ''}`),
  });

  const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
    handleClose: (id: ?number) => dispatch(setUiSetting(`${uiProperty}${id || ''}`, false)),
    handleOpen: (id: ?number) => dispatch(setUiSetting(`${uiProperty}${id || ''}`, true)),
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentToggle);
};
